import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import {
  setEditClientID,
  setReportClient,
  setSort,
  logEmail
} from '../../actions/advisor';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import EditClientForm from './EditClientForm';
import s from './ClientListing.css';

library.add(faChevronUp, faChevronDown, faChevronLeft, faChevronRight);

class ClientListing extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      currPage: 0,
      numPerPage: 10,
    };
    this.paginate = this.paginate.bind(this);
  }

  setEditClientID(clientID) {
    this.props.setEditClientID(clientID);
  }

  setReportClient(clientID) {
    this.props.setReportClient(clientID);
  }

  openClientTest(clientID) {
    window.open('/resource-library/behavioral-finance/?clientID=' + clientID);
  }

  openEmail(client) {
    this.props.logEmail(client);
    const email = client.email;
    const subject = 'WisdomTree Behavioral Finance Tool';
    const body = `Client link: https://${window.location.host}/resource-library/behavioral-finance/?clientID=${client.id}`;
    window.location = `mailto:${email}?subject=${subject}&body=${body}`;
  }

  checkIfEmailSent(client) {
    return client.emails.length > 0 ? true : false;
  }

  checkIfCompleted(client) {
    const completed = client.tests.map((test) => {
      const complete = client.results.filter((result) => result.name === test);
      return complete.length > 0 ? true : false;
    });
    return completed.includes(true) ? true : false;
  }

  checkIfTestAssigned(client) {
    return client.tests.length > 0 ? true : false;
  }

  getLastTestResult(test, results) {
    if (results) {
      const sortedResults = results.filter((result) => result.name === test);
      if (sortedResults.length > 0) {
        return sortedResults[sortedResults.length - 1];
      }
      return null;
    } else {
      return null;
    }
  }

  getLastTestResultScore(test, results) {
    const result = this.getLastTestResult(test, results);
    if (result) {
        const score = result.score[0];
        if (test === NF_TEST) {
          if ( score === 'low') {
            return 1;
          } else if (score === 'med') {
            return 2;
          } else {
            return 3;
          }
        } else {
          return score;
        }
    } else {
      return null;
    }
  }

  setTblHeadClass(type) {
    const {
      sortColumn,
      sortDirection,
    } = this.props;

    if ((type === sortColumn) && (sortDirection === 'DESC')) {
      return (<FontAwesomeIcon icon="chevron-down" size="xs"/>);
    } else if ((type === sortColumn) && (sortDirection === 'ASC')) {
      return (<FontAwesomeIcon icon="chevron-up" size="xs"/>);
    } else {
      return null;
    }
  }

  paginate({selected}) {
    this.setState(Object.assign({}, this.state, {
      currPage: selected,
    }));
  }

  setSortData(col) {
    this.props.setSort(col);
  }

  sortClients() {
    const {
      sortColumn,
      sortDirection,
      clients,
    } = this.props;
    if (sortColumn === 'lastName') {
      clients.sort((a, b) => a[sortColumn].localeCompare(b[sortColumn]));
      if(sortDirection === 'DESC') {
        clients.reverse();
      }
    } else {
      clients.sort((a, b) => {
        const scoreA = this.getLastTestResultScore(sortColumn, a.results);
        const scoreB = this.getLastTestResultScore(sortColumn, b.results);
        if (scoreA === null) {
            return 1;
        } else if (scoreB === null) {
            return -1;
        } else if (scoreA === scoreB) {
            return 0;
        } else if (sortDirection === 'ASC') {
            return scoreA < scoreB ? -1 : 1;
        } else {
          return scoreA < scoreB ? 1 : -1;
        }
      });
    }
  }

  renderClientDetails() {
    const {
      currPage,
      numPerPage,
    } = this.state;
    const {
      clients,
      editClientID,
    } = this.props;

    if (clients && clients.length > 0) {
      this.sortClients();
      const min = currPage * numPerPage;
      const max = min + numPerPage;
      const curClients = clients.slice(min, max);
      return (
        curClients.map((client, index) => {
          const emailSent = this.checkIfEmailSent(client);
          const completed = this.checkIfCompleted(client);
          const testsAssigned = this.checkIfTestAssigned(client);
          const LA = this.getLastTestResult(LA_TEST, client.results);
          const NF = this.getLastTestResult(NF_TEST, client.results);
          const RR = this.getLastTestResult(RR_TEST, client.results);

          return (
            <tbody key={index}>
            <tr>
              <td className={s.nameCell}>
                {completed &&
                  <div className={s.checkmarkIcon} />
                }
                {!completed && emailSent &&
                  <div className={s.waitingIcon} />
                }
                {!completed && !emailSent &&
                  <div className={s.tbdIcon} />
                }
                {client.firstName} {client.lastName}
              </td>
              <td className={s.scoreCell}> {NF ? NF.brief : ''} </td>
              <td className={s.scoreCell}> {LA ? LA.brief : ''} </td>
              <td className={s.scoreCell}> {RR ? RR.brief : ''} </td>
              <td className={s.statusCell} style={{textAlign:'right'}}>
                {client.id !== editClientID &&
                  <Tooltip
                    placement="top"
                    overlay="Edit Client"
                    mouseLeaveDelay={0}
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                    <div className={s.editIcon} onClick={() => this.setEditClientID(client.id)}></div>
                  </Tooltip>
                }
                {client.id === editClientID &&
                  <Tooltip
                    placement="top"
                    overlay="Edit Client"
                    mouseLeaveDelay={0}
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                    <div data-tip="Edit Client" className={s.editIconOn} onClick={() => this.setEditClientID(null)} />
                  </Tooltip>
                }
                {false ?
                  <Tooltip
                    placement="top"
                    overlay="Open Client Tools"
                    mouseLeaveDelay={0}
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                    <div data-tip="Open Client Tools" className={s.linkIcon} onClick={() => this.openClientTest(client.id)} />
                  </Tooltip>
                  :
                  <div className={s.linkIconOff}>&nbsp;</div>
                }
                {false ?
                  <Tooltip
                    placement="top"
                    overlay="Email Client Tools"
                    mouseLeaveDelay={0}
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                    <div data-tip="Email Client Tools" className={s.mailIcon} onClick={() => this.openEmail(client)} />
                  </Tooltip>
                  :
                  <div className={s.mailIconOff}>&nbsp;</div>
                }
                {completed ?
                  <Tooltip
                    placement="top"
                    overlay="Client Report"
                    mouseLeaveDelay={0}
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                    <div data-tip="Client Report" className={s.reportIcon} onClick={() => this.setReportClient(client.id)} />
                  </Tooltip>
                  :
                  <div className={s.reportIconOff}>&nbsp;</div>
                }
              </td>
            </tr>
            {client.id === editClientID &&
              <tr>
                <td colSpan={5} style={{paddingTop:'0px', paddingBottom:'0px'}}>
                    <EditClientForm index={index % 2} client={client} />
                </td>
              </tr>
            }
            </tbody>
          );
        })
      );
    } else {
      return null;
    }
  }

  renderClients() {
    const {
      numPerPage
    } = this.state;
    const {
      clients,
    } = this.props;
    const pageCount = Math.ceil(clients.length / numPerPage);
    if (clients && clients.length > 0) {
      return (
        <div>
          <table className={'table ' + s.clientTable}>
            <thead >
              <tr>
                <th
                  className={s.clientHeaderName}
                  onClick={() => this.setSortData('lastName')}
                >Name {this.setTblHeadClass('lastName')}</th>
                <th
                  className={s.clientHeader}
                  onClick={() => this.setSortData(NF_TEST)}
                >Big Picture {this.setTblHeadClass(NF_TEST)}</th>
                <th
                  className={s.clientHeader}
                  onClick={() => this.setSortData(LA_TEST)}
                >Loss Aversion {this.setTblHeadClass(LA_TEST)}</th>
                <th
                  className={s.clientHeader}
                  onClick={() => this.setSortData(RR_TEST)}
                >Ret. Regret {this.setTblHeadClass(RR_TEST)}</th>
                <th className={s.clientHeader} >&nbsp;</th>
              </tr>
            </thead>
            {this.renderClientDetails()}
          </table>
          <div className="text-center">
          <ReactPaginate
            previousLabel={<FontAwesomeIcon icon="chevron-left" size="xs"/>}
            nextLabel={<FontAwesomeIcon icon="chevron-right" size="xs"/>}
            pageCount={pageCount}
            marginPagesDisplayed={pageCount}
            pageRangeDisplayed={pageCount}
            onPageChange={this.paginate}
            containerClassName={'pagination'}
            pageClassName={'page-item'}
            pageLinkClassName={s.pageLink}
            previousClassName={'page-item'}
            previousLinkClassName={s.pageLink}
            nextClassName={'page-item'}
            nextLinkClassName={s.pageLink}
            activeClassName={s.active}
            disabledClassName={s.disabled}
          />
          </div>
        </div>
      );
    } else {
      return (
        <div>loading</div>
      );
    }
  }

  render() {
    return (
      <div className={s.clientTable + ' row'}>
        <div className="col-md-12">
        {this.renderClients()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clients: state.advisorData.clients,
    editClientID: state.advisorData.editClientID,
    sortColumn: state.advisorData.sortColumn,
    sortDirection: state.advisorData.sortDirection,
  };
}

export default connect(mapStateToProps, {
  setEditClientID,
  setReportClient,
  setSort,
  logEmail,
})(ClientListing);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/ClientListing.js